import { Link } from "@/components/Link";
import { Text } from "@/components/ui/text";
import type { TestSpecDetail } from "../../types";
import { currencyFormatter } from "../../utils/currency";
import { useAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TabLayout } from "../TabLayout";

export function TestSpecPanelsTable({
  testSpec,
}: {
  testSpec: NonNullable<TestSpecDetail>;
}) {
  const panels = testSpec.panels.map((p) => p.panel) || [];

  const { options } = useAdminGridOptions(
    panels,
    [
      {
        field: "name",
        cellRenderer: (params) => (
          <Link to="/admin/panels/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          id: params.data.id,
          name: params.data.name,
        }),
      },
      {
        field: "enabled",
        headerName: "Enabled",
      },
      {
        field: "price",
        headerName: "Price",
        type: "rightAligned",
        cellRenderer: (params) => (
          <Text isDanger={params.value === 0}>
            {currencyFormatter(params.value)}
          </Text>
        ),
        valueGetter: (params) => params.data?.price?.toNumber() ?? 0,
      },
    ],
    { sideBar: undefined },
  );

  return (
    <TabLayout description="Panels this test spec is included in">
      <div className="flex h-96">
        <AdminGrid {...options} />
      </div>
    </TabLayout>
  );
}
